"use strict";

import BaseModel from "dias/core/models/baseModel";


class SitzungsCaches extends BaseModel {
  constructor() {
    super("caches");
  }

  extendCollection(collection) {
    collection = super.extendCollection(collection);

    collection.reset = () => {
      return collection.customPOST({}, "reset");
    };

    return collection;
  }
}

export default SitzungsCaches;
